export enum PushGroups {
  DEFAULT = "default",
}
